export default __webpack_public_path__ + "static/media/sg7.3ca931a0.png";